import { Reducer } from "react"
import { handleActions } from "redux-actions"
import {
    ACTION_GETEXAMINEELIST_SUCCESS,
    ACTION_GETEXAMINEEEXCELTEMPLATE_SUCCESS,
    ACTION_IMPORTEXAMINEESFROMEXCEL_SUCCESS,
    ACTION_GETEXAMINEEDETAIL_SUCCESS
} from "../../actions/silizhu/examinee"

export interface silizhuExamineeState {
    examineeList: any
    examineeExcelTemplateUrl: any
    examineeDetail: any
}

const defaultState: silizhuExamineeState = {
    examineeList: {},
    examineeExcelTemplateUrl: "",
    examineeDetail: {},
}

function handleActionGetExamineeListSuccess (state: silizhuExamineeState, action): silizhuExamineeState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        examineeList: action.payload.data,
        examineeDetail: {},
    }
}

function handleActionGetExamineExcelTemplateSuccess (state: silizhuExamineeState, action): silizhuExamineeState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        examineeExcelTemplateUrl: action.payload.data
    }
}

function handleActionGetExamineDetailSuccess (state: silizhuExamineeState, action): silizhuExamineeState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        examineeDetail: action.payload.data
    }
}

function handleActionNoDataSuccess (state: silizhuExamineeState, action): silizhuExamineeState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    }
}

export const silizhuExamineeReducer: Reducer<silizhuExamineeState, any> = handleActions(
    {
        [ACTION_GETEXAMINEELIST_SUCCESS]: handleActionGetExamineeListSuccess,
        [ACTION_GETEXAMINEEEXCELTEMPLATE_SUCCESS]: handleActionGetExamineExcelTemplateSuccess,
        [ACTION_IMPORTEXAMINEESFROMEXCEL_SUCCESS]: handleActionNoDataSuccess,
        [ACTION_GETEXAMINEEDETAIL_SUCCESS]: handleActionGetExamineDetailSuccess,
    },
    defaultState
)